exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.disabled[data-v-efef3ed0]:hover {\n  cursor: default;\n}\n.settings-category[data-v-efef3ed0] {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  color: #333;\n  margin: 20px;\n}\n.settings-category[data-v-efef3ed0]:hover {\n  color: #333;\n}\n.settings-category__description[data-v-efef3ed0] {\n  text-align: center;\n}\n", ""]);

// exports
